import { Config } from './config.interface';

export const initialConfig: Config = {
  fetched: false,
  verboseLogging: false,
  instrumentationKey: null,
  environment: '',
  launchpadUrl: '',
};
